/**
 * edd_scripts.js — Shopify version (vanilla JS, no jQuery dependency)
 *
 * Ported from WP plugin edd_scripts.js. Changes:
 *   - Removed jQuery dependency (Shopify themes do not always include jQuery)
 *   - AJAX replaced with fetch() + URLSearchParams
 *   - URL changed from admin-ajax.php to App Proxy (/apps/edd)
 *   - WordPress nonce system removed (App Proxy uses HMAC server-side)
 *   - Settings read from window.eddSettings (set inline by Liquid block)
 *
 * @format
 */

(function () {
    'use strict';

    /* Guard against double-execution when multiple blocks load this script */
    if (window.eddScriptsLoaded) return;
    window.eddScriptsLoaded = true;

    /* Shorthand: query all matching elements as an array */
    function qsa(selector) {
        return Array.from(document.querySelectorAll(selector));
    }

    /* Set innerHTML on all matching elements */
    function setHtml(selector, html) {
        qsa(selector).forEach(function (el) { el.innerHTML = html; });
    }

    /* Add or remove the 'open' class on the modal overlay and container */
    function setModalOpen(open) {
        var fn = open ? 'add' : 'remove';
        qsa('.edd-modal-overlay').forEach(function (el) { el.classList[fn]('open'); });
        qsa('.edd-container-modal').forEach(function (el) { el.classList[fn]('open'); });
    }

    document.addEventListener('DOMContentLoaded', function () {

        /* Set button label from settings */
        qsa('.edd-postcode-submit').forEach(function (el) {
            el.textContent = window.eddSettings.send_label;
        });

        /* Open popup when any .edd-open-popup element is clicked */
        qsa('.edd-open-popup').forEach(function (el) {
            el.addEventListener('click', function () { setModalOpen(true); });
        });

        /* Close popup when the overlay background is clicked */
        qsa('.edd-modal-overlay').forEach(function (el) {
            el.addEventListener('click', function () { setModalOpen(false); });
        });

        /* Close popup when the X close button is clicked */
        qsa('.edd-close').forEach(function (el) {
            el.addEventListener('click', function () { setModalOpen(false); });
        });

        /* Submit on Enter key in any postcode input */
        qsa('.edd-postcode-value').forEach(function (el) {
            el.addEventListener('keyup', function (event) {
                if (event.key === 'Enter' || event.keyCode === 13) {
                    var btn = document.querySelector('.edd-postcode-submit');
                    if (btn) btn.click();
                }
            });
        });

        /* Sync postcode value across popup and embedded form inputs */
        qsa('.edd-postcode-value').forEach(function (source) {
            source.addEventListener('input', function () {
                var val = source.value;
                qsa('.edd-postcode-value').forEach(function (other) {
                    if (other !== source) other.value = val;
                });
            });
        });
    });

    /* Handle estimate button click (delegated — works even if button is added later) */
    document.addEventListener('click', function (event) {
        var button = event.target.closest('.edd-postcode-submit');
        if (!button) return;

        /* Clear previous responses */
        setHtml('.edd-response-1', '');
        setHtml('.edd-response-2', '');
        setHtml('.edd-response-3', '');

        /* Client-side validation */
        var postcode = (document.querySelector('.edd-postcode-value') || {}).value || '';
        if (postcode.length < 3 || Number(postcode) < 200) {
            qsa('.edd-postcode-value').forEach(function (el) { el.classList.add('highlight'); });
            return;
        }
        qsa('.edd-postcode-value').forEach(function (el) { el.classList.remove('highlight'); });

        /* Lock button while request is in flight */
        button.style.width = button.offsetWidth + 'px';
        button.textContent = '...';
        button.disabled = true;

        /* POST to Shopify App Proxy — Shopify forwards to VPS proxy.php */
        var body = new URLSearchParams();
        body.append('dst_postcode', postcode);

        /* Include calc settings so VPS can use them without reading settings.json */
        var calc = window.eddSettings.calc || {};
        Object.keys(calc).forEach(function(k) {
            body.append('calc[' + k + ']', calc[k] != null ? calc[k] : '');
        });

        fetch(window.eddSettings.ajaxurl, {
            method: 'POST',
            headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
            body: body.toString()
        })
        .then(function (res) {
            return res.text().then(function (text) {
                try {
                    return JSON.parse(text);
                } catch (e) {
                    throw new Error('Non-JSON response (HTTP ' + res.status + ')');
                }
            });
        })
        .then(function (response) {
            if (response.success) {
                setHtml('.edd-response-1', response.data.parcel.responseText);
                setHtml('.edd-response-2', response.data.express.responseText);
                setHtml('.edd-response-3', response.data.ondemand.responseText);
            } else {
                var msg = (response.data && response.data.message) || (response.error) || window.eddSettings.error;
                setHtml('.edd-response-1', msg);
                setHtml('.edd-response-2', msg);
                setHtml('.edd-response-3', msg);
            }
        })
        .catch(function () {
            setHtml('.edd-response-1', window.eddSettings.error);
            setHtml('.edd-response-2', window.eddSettings.error);
            setHtml('.edd-response-3', window.eddSettings.error);
        })
        .finally(function () {
            button.style.width = '';
            button.textContent = window.eddSettings.send_label;
            button.disabled = false;
            qsa('.edd-postcode-value').forEach(function (el) { el.readOnly = false; });
        });
    });

})();
